import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { useCallback, useMemo } from 'react';
import Raven from 'raven-js';
import { useRemoveFromWatchLater } from '../../watchLater/watchLaterQueries';
import { useAddToWatchLater } from '../../watchLater/watchLaterQueries';
import { useWatchLater } from '../../watchLater/watchLaterQueries';
import UsageTracker from 'academy-common-lib/utils/UsageTracker';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AddedOrRemovedToWatchLaterNotification = ({
  isItemAddedToWatchLater,
  item
}) => {
  if (isItemAddedToWatchLater) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.savedItems.tooltips.removedFromWatchLater",
      options: {
        title: item.name
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.savedItems.tooltips.savedToWatchLater",
    options: {
      title: item.name
    }
  });
};
export const useToggleAddToWatchLater = ({
  id: contentId,
  type: contentType
}) => {
  const {
    data: allWatchLaterItems,
    loading: allWatchLaterItemsLoading
  } = useWatchLater({
    pageLength: 10000,
    // gets full saved items list
    contentTypes: [],
    offset: {
      cursor: 0
    },
    durationFilters: []
  });
  const [addToWatchLater, {
    loading: addToWatchLaterLoading
  }] = useAddToWatchLater({
    contentId,
    contentType: contentType
  });
  const [removeFromWatchLater, {
    loading: removeFromWatchLaterLoading
  }] = useRemoveFromWatchLater({
    contentId,
    contentType: contentType
  });
  const isItemAddedToWatchLater = useMemo(() => allWatchLaterItems === null || allWatchLaterItems === void 0 ? void 0 : allWatchLaterItems.results.some(({
    id,
    type
  }) => id === contentId && type === contentType), [allWatchLaterItems, contentId, contentType]);
  const toggleIsItemAddedToWatchLater = isItemAddedToWatchLater ? removeFromWatchLater : addToWatchLater;
  return {
    isItemAddedToWatchLater,
    toggleIsItemAddedToWatchLater,
    isToggleAddToWatchLaterLoading: addToWatchLaterLoading || removeFromWatchLaterLoading || allWatchLaterItemsLoading
  };
};
const CardMenuWatchLaterOption = ({
  item,
  render = content => {
    return /*#__PURE__*/_jsx(SideNavItem, {
      role: "navigation-item",
      title: content
    });
  },
  onClick
}) => {
  const {
    isItemAddedToWatchLater,
    toggleIsItemAddedToWatchLater,
    isToggleAddToWatchLaterLoading
  } = useToggleAddToWatchLater(item);
  const handleOnClick = useCallback(() => {
    onClick === null || onClick === void 0 || onClick();
    if (isToggleAddToWatchLaterLoading) return;
    toggleIsItemAddedToWatchLater().then(() => {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(AddedOrRemovedToWatchLaterNotification, {
          isItemAddedToWatchLater: !!isItemAddedToWatchLater,
          item: item
        }),
        type: 'success'
      });
      UsageTracker.trackStandalone('Learning Center Interaction', {
        action: isItemAddedToWatchLater ? 'favorite-removed' : 'favorite-added',
        contentId: item.id,
        contentType: item.type
      });
    }).catch(Raven.captureException);
  }, [isItemAddedToWatchLater, isToggleAddToWatchLaterLoading, item, onClick, toggleIsItemAddedToWatchLater]);
  return /*#__PURE__*/_jsx("div", {
    "aria-disabled": isToggleAddToWatchLaterLoading,
    "data-test-id": "watch-later-button",
    onClick: handleOnClick,
    children: render( /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx("span", {
        style: {
          flex: isToggleAddToWatchLaterLoading ? undefined : 1,
          opacity: isToggleAddToWatchLaterLoading ? 0.3 : 1
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: isItemAddedToWatchLater ? 'academyCommon.cardMenu.removeFromWatchLater' : 'academyCommon.cardMenu.addToWatchLater'
        })
      }), isToggleAddToWatchLaterLoading && /*#__PURE__*/_jsx(LoadingSpinner, {
        margin: "0",
        size: "extra-small"
      })]
    }))
  });
};
export default CardMenuWatchLaterOption;